import { mlsListings } from '@prisma/client';
import axiosInstance from '../api';

export interface MlsListingSearchParams {
  latitude?: number;
  longitude?: number;
  radius?: number;
  minBeds?: number;
  maxBeds?: number;
  minBaths?: number;
  maxBaths?: number;
  minPrice?: number;
  maxPrice?: number;
  minLotSize?: number;
  propertyType?: string;
  state?: string | string[];
  city?: string;
  isAssumable?: boolean;
  size?: number;
  zoom?: number; // Used for cache key precision
  hasConcessions?: boolean; // Filter to only show listings with seller concessions
  bounds?: {
    north: number;
    south: number;
    east: number;
    west: number;
  };
}

const mlsListingsService = {
  find: async (
    params: MlsListingSearchParams,
    signal?: AbortSignal
  ): Promise<mlsListings[]> => {
    const response = await axiosInstance.get('/mls-listings', {
      params,
      signal,
    });
    return response.data.data || response.data;
  },

  get: async (id: string, signal?: AbortSignal): Promise<mlsListings> => {
    const response = await axiosInstance.get(`/mls-listings/${id}`, {
      signal,
    });
    return response.data;
  },
};

export default mlsListingsService;
